<template>
  <v-container fluid grid-list-xs style="padding: 0;" v-if="ready">
    <v-layout row wrap v-if="system">
      <v-flex v-for="data in system_channels" :key="data.key" md3 sm4 xs6>
        <item :data="data"></item>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else-if="developer">
      <v-flex v-for="data in developer_channels" :key="data.key" md3 sm4 xs6>
        <item :data="data" :developer="true"></item>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex v-for="data in filtered_channels" :key="data.key" md3 sm4 xs6>
        <item :data="data"></item>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';
import Item from './Item'
import naturalSort from 'natural-sort'

export default {
  props: ['system', 'developer'],
  components: {
    Item
  },
  data () {
    return {
      naturalSort: naturalSort(),
      ready: false
    }
  },
  computed: {
    monitor_filters () {
      return this.$store.state.account.meta.monitor_channel_filter ||[];
    },
    instances() {
      return this.$store.state.instances;
    },
    developer_channels () {
      return _.filter(this.channels, (channel) => {
        var instance = ChannelModel.instance(channel.channel, null);
        return _.get(instance, "meta.is_developer", false);
      }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    system_channels () {
      return _.filter(this.channels, (channel) => { return this.monitor_filters.includes(channel.key) && _.get(channel, "channel.meta.system_channel", false); }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    filtered_channels () {
      return _.filter(this.channels, (channel) => { 
        if(!this.monitor_filters.includes(channel.key)) return false;
        var instance = ChannelModel.instance(channel.channel, null);
        if (_.get(instance, "meta.is_developer", false) == true) return false;
        return !_.get(channel, "channel.meta.system_channel", false); 
      }).sort((a,b) => {
        var aTitle = _.get(a, "channel.title", "");
        var bTitle = _.get(b, "channel.title", "");
        return this.naturalSort(aTitle, bTitle);
      });
    },
    channels () {
			var st = ChannelModel.status_all();
			if (typeof(st) != "undefined") {
				var res = [];
        _.each(st, (data, id) => {
          var headend = this.instances[data.headend_instance];
          var state = (this.get_source_state(data)||{}).state;
          if (typeof(headend) != "undefined") {
            var channel = ChannelModel.channel_by_uuid(id);
            if(channel) res.push({key: id, state: state, channel: channel, url: InstanceModel.headend_preview_url(headend, id)});
          }
        });
        return res;
			}
			return [];
		}
  },
  methods: {
    get_state(data, type) {
			var i = data.instance;
			if (typeof(i) != "undefined") {
				var s = i[type];
				if (typeof(s) != "undefined") {
					return s;
				}
			}
			return;
		},

		get_source_state(data) {
			return this.get_state(data, "source");
		}
  },
  mounted() {
    this.$store.dispatch("get_profile").then(() => {
      this.$nextTick(() => {
        this.ready = true;
      });
    }, () => {});
  }
}
</script>
